import React from 'react';
import clsx from 'clsx';

import PropTypes from 'prop-types';

import {makeStyles} from '@material-ui/styles';
import {Grid, Typography} from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {}
}));

function Header({className, ...rest}) {
  const classes = useStyles();

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        alignItems="center"
        container
        justify="space-between"
        spacing={3}
      >
        <Grid
          item
          md={6}
          xs={12}
        >
          <Typography
            component="h2"
            gutterBottom
            variant="overline"
          >
            Menu
          </Typography>
          <Typography
            component="h1"
            gutterBottom
            variant="h3"
          >
            Feedback
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
